import { PropsWithChildren, createContext, memo, use, useState } from 'react';

import { BuyeasyStoreConfig } from '../types/schemas/objects/BuyeasyStoreConfig';

export type StoreConfig = BuyeasyStoreConfig | null;

type StoreConfigContextValue = {
	storeConfig: StoreConfig;
	setStoreConfig: (storeConfig: StoreConfig) => void;
};

const StoreConfigContext = createContext<StoreConfigContextValue>({
	storeConfig: null,
	setStoreConfig: () => {},
});

export const useStoreConfig = () => use(StoreConfigContext);

export const StoreConfigProvider = memo(({ children }: PropsWithChildren) => {
	const [storeConfig, setStoreConfig] = useState<StoreConfig>(null);

	return (
		<StoreConfigContext
			value={{
				storeConfig,
				setStoreConfig,
			}}
		>
			{children}
		</StoreConfigContext>
	);
});

StoreConfigProvider.displayName = 'StoreConfigProvider';
